import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ThemeProvider } from "styled-components";
import store from "./redux/store";
import AppRouter from "./Router";
import theme from "./styles/theme";
import GlobalStyles from "./styles/GlobalStyles";

// let socket = io.connect("https://dev.socket.truckfix-chat.bstorm.app");

// Suppress benign ResizeObserver error that React dev overlay catches
const resizeObserverErr = window.addEventListener("error", (e) => {
  if (e.message === "ResizeObserver loop completed with undelivered notifications.") {
    e.stopImmediatePropagation();
  }
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <React.StrictMode>
        <AppRouter />
      </React.StrictMode>
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);
